import ApiCompanies from '../api/companies'
import { app } from '../index'

export default {
  methods: {
    checkCompany () {
      if (this.$store.getters['auth/roles'].includes('employer') || this.$store.getters['auth/roles'].includes('recruiter')) {
        ApiCompanies.getMyCompanyStatus()
          .then(response => {
            if (response.data.status === 'recent') {
              this.$swal({
                showCancelButton: true,
                confirmButtonText: app.$t('general.company_popup.go_to_company_edit'),
                cancelButtonText: app.$t('general.company_popup.delay_company_edit'),
                title: app.$t('general.company_popup.title'),
                text: app.$t('general.company_popup.text')
              })
                .then(result => {
                  if (result.dismiss) {
                  } else {
                    app.$router.push({ name: 'company_edit_path' })
                  }
                })
            }
          })
          .catch(error => {
            console.error(error)
          })
      }
    }
  }
}
